export default {
  updateLoading({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  openAuthModal({ commit }, payload) {
    commit('SET_AUTH_MODAL_STATUS', payload)
  },
  setSuccessRegistration({ commit }, payload) {
    commit('SET_SUCCESS_REGISTRATION_STATUS', payload)
  },
  setWaitTransaction({commit}, payload) {
    commit('SET_WAIT_TRANSACTION', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js